import { PayRentTypes } from '../../PayRentTypes';
import {
  amountResolutionType,
  currentBalanceNotAvailable,
  paymentMethodType,
} from '../../constants/accountPanelConfigs';
import { getDecimalBalance } from '../../helpers/accountPanelHelper';
import { getCardTypeFromPaymentMethodId } from './CardTypeIcon';
import { ExistingCardSection } from './ExistingCardSection';
import { NewCardSection } from './NewCardSection';
import * as React from 'react';

export const PayRentForm = ({
  billingDetailsConfig,
  callBackHandler,
  payment_method,
  public_key,
  address,
  name,
  card_info,
  preferred_payment_method_id,
  masked_card_number,
  cardProcessorIds,
  is_auto_pay_enabled,
  isSurchargeOrDiscountAvailable,
  tenantWebsitesConfigInfo: {
    data: [{ value: { payment: tfwPaymentConfig = {} } = {} } = {}] = [],
  },
  facilityId,
  tenantToken,
}: PayRentTypes.TPayRentForm) => {
  const customAmountError = React.useRef<any>();
  const current_balance_due = billingDetailsConfig?.current_balance_due || 0;
  // This state stores the user entered amount
  const [customAmount, setCustomAmount] = React.useState(
    Number(current_balance_due) > 0
      ? getDecimalBalance(current_balance_due)
      : currentBalanceNotAvailable
  );
  const [amountResolution, setAmountResolution] = React.useState(
    amountResolutionType.balanceAmount
  );
  const [paymentType, setPaymentType] = React.useState(
    paymentMethodType.creditCard
  );
  const [chargesDetails, setChargesDetails] = React.useState<any>({});

  const billingDetails = {
    ...billingDetailsConfig,
    ...(isSurchargeOrDiscountAvailable && { new_balance: current_balance_due }),
    ...(isSurchargeOrDiscountAvailable &&
      Object.keys(chargesDetails).length !== 0 && {
        charge_amount: chargesDetails?.charge_amount,
        chargeType: chargesDetails?.chargeType,
        new_balance: chargesDetails?.amount,
        original_amount: chargesDetails?.amount_without_modifer,
      }),
  };

  const commonProps = {
    callBackHandler,
    billingDetailsConfig: billingDetails,
    public_key,
    payment_method,
    cardProcessorIds,
    isSurchargeOrDiscountAvailable,
    tfwPaymentConfig,
    facilityId,
    customAmount,
    setCustomAmount,
    preferred_payment_method_id,
    chargesDetails,
    setChargesDetails,
    customAmountError,
    amountResolution,
    setAmountResolution,
    paymentType,
    setPaymentType,
    tenantToken,
  };
  const getCurrentComponent = () => {
    if (masked_card_number) {
      const cardType = getCardTypeFromPaymentMethodId(
        payment_method,
        preferred_payment_method_id
      );
      const card_holder_info = {
        name,
        address,
      };
      const existingCardProps = {
        ...commonProps,
        cardType,
        card_holder_info,
        card_info,
        is_auto_pay_enabled,
      };
      return (
        <div data-testid="existing-card-section">
          <ExistingCardSection {...existingCardProps} />
        </div>
      );
    } else {
      return (
        <div data-testid="new-card-secction">
          <NewCardSection
            {...commonProps}
            parentChargeDetailsUpdater={setChargesDetails}
          />
        </div>
      );
    }
  };
  return <>{getCurrentComponent()}</>;
};
